import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import { RootState } from "../store";
import { userSliceActions } from "../store/user-slice";

interface PrivateProps {
  Component: FC;
  requiredRoles: string[];
}

const Private: FC<PrivateProps> = ({ Component, requiredRoles }) => {
  const dispatch = useDispatch();
  const { isSignedIn, roles } = useSelector((state: RootState) => state.user);
  const location = useLocation();
  const isAuthorized =
    isSignedIn && requiredRoles.some((role) => roles.includes(role));

  useEffect(() => {
    if (!isSignedIn) {
      // Store the location they were trying to access (with search params) for post-login redirect
      const redirectUrl = location.pathname + location.search;
      dispatch(userSliceActions.setPendingRedirectUrl(redirectUrl));
    }
  }, [isSignedIn, location, dispatch]);

  if (!isSignedIn) {
    return <Navigate to="/signin" />;
  }

  return isAuthorized ? <Component /> : <Navigate to="/" />;
};

export default Private;
